const state = {
  quote_journey_session: {
    evCompare: false,
    evOnly: false,
    ashp: false,
    solar: false
  },
  quote: {
    quoteType: null,
    address: {},
    switchType: null,
    heatFuel: null,
    switchId: null
  }
};

const getters = {
  journeyType: (state) => {
    const { quote_journey_session } = state;

    if (quote_journey_session.evCompare) {
      return 'Electric Vehicle Comparison';
    }

    if (quote_journey_session.evOnly) {
      return 'Electric Vehicle Only';
    }

    if (quote_journey_session.ashp) {
      return 'Air Source Heat Pump';
    }

    if (quote_journey_session.solar) {
      return 'Solar & Battery';
    }

    return 'None';
  }
};

const actions = {
  initialiseSession({ commit }) {
    Object.entries(sessionStorage).forEach(([key, value]) => {
      commit('updateState', { key, value: parseJson(value) });
    });
  },
  setItem({ commit }, { key, value }) {
    sessionStorage.setItem(key, stringifyJson(value));
    commit('updateState', { key, value });
  }
};

const mutations = {
  updateState(state, { key, value }) {
    state[key] = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

function parseJson(val) {
  try {
    return JSON.parse(val);
  } catch (e) {
    return val;
  }
}

function stringifyJson(val) {
  try {
    return JSON.stringify(val);
  } catch (e) {
    return '';
  }
}
